<template>
  <div class="daily-cargo-rac-validation">
    <div>
      <div v-if="update === true" style="grid-column: 2; grid-row: 1;">
        <form-button @onClick="updateRacValidationData">
          Update RAC Validation
        </form-button>
      </div>
      <table v-if="update === true">
        <thead>
          <tr class="daily-cargo-rac-validation__head">
            <th
              v-for="(header, index) in tableFields"
              :key="'dashboardPrecariageHeader' + index">
              <span />
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(dailyCargo, dailyCargoIndex) in dailyCargoRacValidation"
            :key="'dailyCargoTable' + dailyCargoIndex">
            <td
              v-for="(field, fieldIndex) in tableFields"
              :key="'dashboardPrecariageField' + dailyCargoIndex + '.' + fieldIndex"
              class="daily-cargo-rac-validation__field">
              <span>
                {{ dailyCargo[field.name] }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="daily-cargo-rac-validation__fields">
        <div style="grid-column: 1; grid-row: 1;">
          <form-filtered-select
            v-model="orderedUserList.value"
            :options="orderedUserList"
            :selected-key="orderedUserList.value"
            placeholder="Users"
            @updateDropdownValue="onUpdateValue"
            @close="$emit('close')" />
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-input
            v-model="unionDBCheck"
            v-mask="['##:##']"
            placeholder="Validatioin Time" />
        </div>
        <div style="grid-column: 1; grid-row: 2;">
          <form-label>X-Ray Agilent (SCA)</form-label>
          <form-input
            v-model="agilentXRay"
            v-mask="['##:##']"
            placeholder="Validatioin Time" />
        </div>
        <div style="grid-column: 2; grid-row: 2;">
          <form-label>X-Ray Agilent (FR)</form-label>
          <form-input
            v-model="agilentFRXRay"
            v-mask="['##:##']"
            placeholder="Validatioin Time" />
        </div>
        <div style="grid-column: 3; grid-row: 2;">
          <form-label>X-Ray Sysmex / Roche</form-label>
          <form-input
            v-model="sysmexRocheXRay"
            v-mask="['##:##']"
            placeholder="Validatioin Time" />
        </div>
        <div style="grid-column: 4; grid-row: 2;">
          <form-label>X-Ray CNH</form-label>
          <form-input
            v-model="cnhXRay"
            v-mask="['##:##']"
            placeholder="Validatioin Time" />
        </div>
        <div style="grid-column: 5; grid-row: 2;">
          <form-label>X-Ray GE Healthcare</form-label>
          <form-input
            v-model="geHealthcareXRay"
            v-mask="['##:##']"
            placeholder="Validatioin Time" />
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-button @onClick="saveRacValidationData">
            Save RAC Validation
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import constants from '@/constants'
const messageDialog = create(MessageDialog, 'content')

export default {
  data () {
    return {
      isLoading: false,
      selectedUser: null,
      update: false,
      agilentXRay: '',
      kvernelandXRay: '',
      agilentFRXRay: '',
      sysmexRocheXRay: '',
      cnhXRay: '',
      geHealthcareXRay: '',
      hiabXRay: '',
      unionDBCheck: '',
      orderedUserList: [],
      time: '',
      tableFields: [
        { name: 'RAC_Check_By_Name', label: 'Name', type: 'String' },
        { name: 'RAC_Time', label: 'Time', type: 'String' }
      ]
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['dailyCargoRacValidation']),
    ...mapState('userManagment', ['activeUserList'])
  },
  watch: {
    dailyCargoRacValidation: {
      handler: function () {
        if (this.dailyCargoRacValidation.length > 0) {
          this.update = true
        } else {
          this.update = false
        }
      },
      deep: true
    }
  },
  created () {
    this.loadDailyCargoRacValidation()
    this.loadActiveUserList().then(() => {
      this.fillUserList()
    })
  },
  methods: {
    ...mapActions('dailyCargo', ['loadDailyCargoRacValidation', 'saveRacValidation']),
    ...mapActions('userManagment', ['loadActiveUserList']),
    goToUnionDatabase () {
      window.open(constants.EXTERNAL_LINKS.Daily_Cargo_Union_DB, '_blank')
    },
    fillUserList () {
      if (this.orderedUserList.length === 0) {
        this.activeUserList.forEach((us) => {
          var user = { value: us.Full_Name, label: us.Full_Name }
          this.orderedUserList.push(user)
        })
      }
    },
    onUpdateValue (value) {
      this.selectedUser = value
    },
    updateRacValidationData () {
      this.update = false
      var agilentXRay_Countries = constants.COUNTRY_ID.DENMARK + ',' + constants.COUNTRY_ID.SWEDEN + ',' + constants.COUNTRY_ID.FINLAND
      var agilentXRay_Customers = constants.CUSTOMER_ID.AGILENT + ',' + constants.CUSTOMER_ID.AGILENT_ERC
      var sysmexRocheXRay_Customers = constants.CUSTOMER_ID.SYSMEX
      var cnhXRay_Countries = constants.COUNTRY_ID.NORWAY + ',' + constants.COUNTRY_ID.SWEDEN + ',' + constants.COUNTRY_ID.FINLAND
      var geHealthcareCountries = constants.COUNTRY_ID.SWEDEN + ',' + constants.COUNTRY_ID.NORWAY + ',' + constants.COUNTRY_ID.DENMARK + ',' + constants.COUNTRY_ID.FINLAND

      this.unionDBCheck = this.getRacTime('-1', '-1')
      this.orderedUserList.value = this.dailyCargoRacValidation.filter(e => e.Customer_ID === '-1' && e.Country_ID === '-1')[0].RAC_Check_By_Name
      this.sysmexRocheXRay = this.getRacTime(sysmexRocheXRay_Customers, constants.COUNTRY_ID.FRANCE.toString())
      this.agilentXRay = this.getRacTime(agilentXRay_Customers, agilentXRay_Countries)
      this.cnhXRay = this.getRacTime(constants.CUSTOMER_ID.CNH.toString(), cnhXRay_Countries)
      this.geHealthcareXRay = this.getRacTime(constants.CUSTOMER_ID.GE_HEALTHCARE.toString(), geHealthcareCountries)
      this.agilentFRXRay = this.getRacTime(constants.CUSTOMER_ID.AGILENT.toString(), constants.COUNTRY_ID.FRANCE.toString())
    },
    getRacTime (customers, countries) {
      return this.dailyCargoRacValidation.filter(e => e.Customer_ID === customers && e.Country_ID === countries)[0].RAC_Time
    },
    saveRacValidationData () {
      var racValidationData =
      {
        Rac_Validation_Data_ID: 1,
        rac_Validation_Data_Lists: [{
          RAC_Check_By_Name: this.selectedUser.value,
          RAC_Time: this.unionDBCheck,
          Customer: '-1',
          Country: '-1'
        }, {
          RAC_Check_By_Name: 'X-Ray Agilent (SCA)',
          RAC_Time: this.agilentXRay,
          Customer: constants.CUSTOMER_ID.AGILENT + ',' + constants.CUSTOMER_ID.AGILENT_ERC,
          Country: constants.COUNTRY_ID.DENMARK + ',' + constants.COUNTRY_ID.SWEDEN + ',' + constants.COUNTRY_ID.FINLAND
        }, {
          RAC_Check_By_Name: 'X-Ray Sysmex / Roche',
          RAC_Time: this.sysmexRocheXRay,
          Customer: constants.CUSTOMER_ID.SYSMEX,
          Country: constants.COUNTRY_ID.FRANCE
        }, {
          RAC_Check_By_Name: 'X-Ray CNH',
          RAC_Time: this.cnhXRay,
          Customer: constants.CUSTOMER_ID.CNH,
          Country: constants.COUNTRY_ID.NORWAY + ',' + constants.COUNTRY_ID.SWEDEN + ',' + constants.COUNTRY_ID.FINLAND
        }, {
          RAC_Check_By_Name: 'X-Ray GE Healthcare',
          RAC_Time: this.geHealthcareXRay,
          Customer: constants.CUSTOMER_ID.GE_HEALTHCARE,
          Country: constants.COUNTRY_ID.NORWAY + ',' + constants.COUNTRY_ID.SWEDEN + ',' + constants.COUNTRY_ID.FINLAND + ',' + constants.COUNTRY_ID.DENMARK
        }, {
          RAC_Check_By_Name: 'X-Ray Agilent (FR)',
          RAC_Time: this.agilentFRXRay,
          Customer: constants.CUSTOMER_ID.AGILENT,
          Country: constants.COUNTRY_ID.FRANCE
        }]
      }

      this.isLoading = true
      this.saveRacValidation(racValidationData).then((response) => {
        this.isLoading = false
        this.update = true
        messageDialog('Successfully Saved!')
      }).catch((error) => {
        this.isLoading = false
        messageDialog('Something went wrong: ' + error.ExceptionMessage)
      })
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-rac-validation {
    width: 100%;
    height: calc(100vh - 205px);
    padding-bottom: 20px;
    overflow: auto;

    &__fields {
      display: grid;
      grid-template-columns: 19% 19% 19% 19% 19%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
        &:nth-child(even) {
          background: $tableHeaderBackgroundColor;
        }
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
  }
</style>
